// resumeData.js
const ResumeData = {
  basics: {
    name: "Marcus Ko",
    title: "Senior Front End Developer",
    email: "marcusko@gmail.com",
    phone: "(847) 309-6079",
    profileLink1: "https://www.linkedin.com/in/marcusko",
    profileLink2: "https://react-my-portfolio-six.vercel.app/"
  },
  headings: {
    summary: "Summary",
    technical: "Technical Proficiencies",
    experience: "Experience",
    education: "Education"
  },
  skills: [
    {
      summary: "Adept at architecting, designing, and developing scalable and well-documented code..."
    }
  ],
  technical: {
    languages: ["HTML", "CSS", "JavaScript", "React"],
    frameworks: ["Node.js", "Modular JavaScript", "ASP.net", "Bootstrap"],
    tools: ["jQuery", "gulp.js", "pugjs", "Sitecore", "Figma", "Jira", "GIT", "GitHub", "GSAP", "AWS S3", "BrowserStack", "Azure Media Services"],
    preprocessors: ["LESS", "SASS"]
  },
  experience: [
    {
      company: "Primus Home Care Solutions Inc.",
      startDate: "2023",
      endDate: "Present",
      role: "Senior Front End Developer",
      highlights: [
        "Redesigned local business site, modernizing UI/UX and cross-device functionality.",
        "Built reusable code, created updated graphics and video content.",
        "Implemented interactive Google Map search experience.",
        "Launched new SEO and accessibility-focused site with modern tech stack."
      ]
    },
    {
      company: "1800Flowers.com",
      startDate: "2021",
      endDate: "Present",
      role: "Senior Front End Developer",
      highlights: [
        "Built and maintained 4 eCommerce sites using Visual Studio, ASP.net, LESS, and jQuery.",
        "Led onboarding and code reviews for new hires.",
        "Improved checkout and personalization flows, boosting engagement.",
        "Architected and launched ThingsRemembered.com, cutting dev time 30%.",
        "Developed reusable Design System to streamline styling workflows."
      ]
    },
    {
      company: "Allstate",
      startDate: "2017",
      endDate: "2021",
      role: "Front End Developer",
      highlights: [
        "Architected public-facing sites and internal apps using React, SASS, and Sitecore.",
        "Documented dev workflows and trained backend devs on front-end standards.",
        "Integrated React Redux with CMS for real-time content updates.",
        "Collaborated cross-functionally on Claims Mobile App and internal tools.",
        "Launched interactive revenue-generating projects with GSAP and HTML emails."
      ]
    },
    {
      company: "Sears",
      startDate: "2015",
      endDate: "2016",
      role: "Graphic Designer II",
      highlights: [
        "Created digital assets for websites, social media, and print.",
        "Produced and edited corporate video content for internal and external audiences.",
        "Animated Sears Parts Direct promo video that earned 265k+ views on YouTube."
      ]
    },
    {
      company: "Baystone Media",
      startDate: "2014",
      endDate: "2015",
      role: "Web Domain Administrator",
      highlights: [
        "Managed 5000+ domain transfers and supported international clients.",
        "Created and distributed branded email newsletters.",
        "Wrote documentation and trained new hires on support procedures.",
        "Provided top-tier support for domain, email, and hosting platform issues."
      ]
    }
  ],
  education: [
    {
      institution: "Columbia College Chicago",
      studyType: "Bachelor of Arts",
      area: "Multimedia"
    },
    {
      institution: "Thinkful",
      studyType: "Full Stack Web Developer Bootcamp",
      area: "2017"
    }
  ]
};

export default ResumeData;